import Q from 'q';

import API from 'js/lib/api';

import S3Upload from 'bundles/enterprise-admin-program-users/utils/s3uploader';

const curriculumBuilderAPI = API('/api/grpc/curriculumbuilder/v1beta1/CurriculumBuilderAPI/', { type: 'rest' });

type S3Object = {
  s3Bucket: string;
  s3Key: string;
  signedUploadUrl: string;
};

const getS3Location = (orgId: string, callback: (res: $TSFixMe) => void) => {
  return Q(curriculumBuilderAPI.post('GenerateBulkUploadLocation', { data: { organizationId: orgId } })).then((res) => {
    callback(res);
  });
};

const importAccreditationTags = (
  orgId: string,
  onSuccessfulUpload: () => void,
  onFailedUpload: () => void,
  { s3Bucket, s3Key }: S3Object
) => {
  return Q(
    curriculumBuilderAPI
      .post('ImportAccreditationTags', { data: { organizationId: orgId, s3Bucket, s3Key } })
      .then((res) => {
        if (!res?.newTags) {
          onFailedUpload();
        } else {
          onSuccessfulUpload();
        }
      })
  ).catch(() => {
    onFailedUpload();
  });
};

export const uploadAccreditationTags = (
  file: File,
  orgId: string,
  onSuccessfulUpload: () => void,
  onFailedUpload: () => void
) => {
  const s3Uploader = new S3Upload({
    getSignedUrl: getS3Location.bind(this, orgId) as $TSFixMe,
    onFinishS3Put: importAccreditationTags.bind(this, orgId, onSuccessfulUpload, onFailedUpload) as $TSFixMe,
  });

  s3Uploader.handleFileSelect(file);
};
